<template>
  <span>
      <div class="home_navi">
          <router-link to="/" class="home arr">&nbsp;</router-link><i>&nbsp;</i>

          <router-link      v-if="'info'    in $attrs" to="/info/info_kind"         >경유증표안내</router-link>
          <router-link v-else-if="'notice'  in $attrs" to="/board/board_list"       >공지사항</router-link>
          <router-link v-else-if="'buy'     in $attrs" to="/buy/buy_form"           >증표 구입</router-link>
          <router-link v-else-if="'use'     in $attrs" to="/use/use_via"            >증표 <font>사용</font>·입력·조회</router-link>
          <router-link v-else-if="'apply'   in $attrs" to="/apply/viafree_req"      >신고·신청</router-link>
          <router-link v-else-if="'report'  in $attrs" to="/report/report_viacnt"   >수임사건 내역 조회</router-link>
          <router-link v-else-if="'mypage'  in $attrs" to="/mypage/qna"             >마이페이지</router-link>
          <!-- <router-link v-else-if="'viainfo' in $attrs" to="/mypage/qna"             >증표정보</router-link> -->

          <font v-html="title"></font>
      </div>

      <div class="sub_title" v-if="hideSubtitle != true">
        <h3 v-html="title"></h3>
      </div>
  </span>
</template>

<script>
export default {
  props : {
    title: {},
    hideSubtitle: { type: Boolean, default: false, } // 부제목 감추기 옵션
  },
}
</script>